<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <a-input v-model="queryParams.itemCode" disabled ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="日期">
              <a-date-picker
                v-model="queryParams.nowDate"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="addLine()" type="primary">新增</a-button>
      <a-button :loading="isLoading" @click="save()" type="primary">保存</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <template slot="sourceSupplierName" slot-scope="{ record } ">
            <!-- <global-select
              @change="(val)=>itemCodeHandler(val, record)"
              :value.sync="record.sourceSupplierName"
              selectType="select"
              :dropdown-match-select-width="false"
              requestApi="/mdm/mdmOrgSrAssignments/mdmOrgSupplierList"
              :selectItem="{ value: 'realValue', label: 'label' }"
            /> -->
            <div v-if="supplierOptionsflag(supplierOptions, record)">
              <a-select @change="(val)=>handlerSupplierName(val,record)" v-model="record.sourceSupplierId" >
                <a-select-option v-for="(item) in supplierOptions" :key="item.selectedValue">{{ item.realValue }}</a-select-option>
              </a-select>
            </div>
            <div v-else>
              <a-select @change="(val)=>handlerSupplierName(val,record)" v-model="record.sourceSupplierName" >
                <a-select-option v-for="(item) in supplierOptions" :key="item.selectedValue">{{ item.realValue }}</a-select-option>
              </a-select>
            </div>
          </template>
          <template slot="allocationPercent" slot-scope=" { record } ">
            <a-input-number :formatter="value => value?`${value}%`:''"
                            :parser="value => value.replace('%', '')" v-model="record.allocationPercent" :min="0" :max="100"/>
          </template>
          <template slot="startDateActive" slot-scope=" { record } ">
            <a-date-picker :disabled-date="disabledStartDateActive" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" v-model="record.startDateActive" />
          </template>
          <template slot="endDateActive" slot-scope=" { record } ">
            <a-date-picker :disabled-date="disabledEndDateActive" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" v-model="record.endDateActive" />
          </template>
          <template slot="month" slot-scope=" { record } ">
            <a-month-picker valueFormat="YYYY-MM" format="YYYY-MM" v-model="record.month" />
          </template>
          <template slot="index" slot-scope="{ index }">
            <span>{{ index+1 }}</span>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="effectFlag" slot-scope="{ record }">
            <span>{{ record.effectFlag?(record.effectFlag==='1'?'启用':'禁用') :'' }}</span>
            <!-- <span>{{ record.effectFlag }}</span> -->

          </template>
          <template slot="status" slot-scope="{ record }">
            <a-switch :disabled="!isEdit || currentId !== record.id" :checked="record.status === 'Y'" @change="statusOnChange(record)" />
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a @click="handleDelete(record)">删除</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js';
import { apiMdmOrgSrAssignmentsLinelist, apiMdmOrgSrAssignments, apiMdmOrgSupplierList, apiDelItemApportion } from '@/api/mps/basic-data/product-source-rules.js';
export default {
  // eslint-disable-next-line
  name: 'detail', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
  components: {
  },
  data () {
    return {
      supplierOptions: [],
      isLoading: false,
      itemCode: undefined,
      sourceOrganization: undefined,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMdmOrgSrAssignmentsLinelist, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        itemCode: undefined,
        assignmentSetId: undefined,
        nowDate: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 表格字段
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' },
          align: 'center',
          width: 100
        },
        // {
        //   title: '物料编码',
        //   dataIndex: 'itemCode',
        //   width: 160,
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '来源供应商',
          dataIndex: 'sourceSupplierName',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'sourceSupplierName' },
          align: 'center'
        },
        {
          title: '分配比例',
          dataIndex: 'allocationPercent',
          scopedSlots: { customRender: 'allocationPercent' },
          width: 160,
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '生效日期',
        //   dataIndex: 'startDateActive',
        //   scopedSlots: { customRender: 'startDateActive' },
        //   width: 160,
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '失效日期',
        //   dataIndex: 'endDateActive',
        //   width: 160,
        //   scopedSlots: { customRender: 'endDateActive' },
        //   align: 'center'
        // },
        {
          title: '有效月份',
          dataIndex: 'month',
          width: 160,
          scopedSlots: { customRender: 'month' },
          align: 'center'
        },
        {
           title: '来源编码',
           align: 'center',
           width: 150,
          dataIndex: 'sourceCode'
        },
        {
           title: '状态',
           width: 150,
           scopedSlots: { customRender: 'effectFlag' },
          dataIndex: 'effectFlag'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      uomClassOptions: [], // 来源分类
      unitOfMeasureList: [], // 来源单位
      unitOfMeasureListNew: [] // 基本单位
    }
  },
  created () {
    this.queryParams.itemId = this.$route.query.itemId
    this.queryParams.itemCode = this.$route.query.itemCode
    this.queryParams.assignmentSetId = this.$route.query.assignmentSetId
    this.sourceOrganization = this.$route.query.sourceOrganization
    // 获取今天的日期并格式化为 "YYYY-MM-DD" 格式
    // const formattedDate = moment().format('YYYY-MM-DD');

    // // 将格式化后的日期赋值给 queryParams.nowDate
    // this.queryParams.nowDate = formattedDate;

  //  this.getUnitOfMeasureList()
    // const lookupQueryParams = {
    //   lookupType: 'MDM_UOM_CLASSES',
    //   current: 1,
    //   pageSize: 100
    // }
    // this.getLookupListData(lookupQueryParams).then().then(response => {
    //   this.uomClassOptions = response.rows
    // })
    apiMdmOrgSupplierList({ itemId: this.queryParams.itemId, assignmentSetId: this.queryParams.assignmentSetId }).then((response) => {
      this.supplierOptions = response
    })
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 判断列数据的来源供应商
    supplierOptionsflag (arr, row) {
      if (!row.sourceSupplierId) {
        return true
      } else {
        arr.find(item => item.label === row.sourceOrganization)
      }
    },
    handlerSupplierName (val, record) {
      const existingItem = this.supplierOptions.find(entry => entry.selectedValue === val);
      record.sourceSupplierName = val
      // 这是一段神奇的代码，居然同时绑定id和name,为了不影响旧数据的展示，也只能这样改了
      record.sourceSupplierId = val
      record.sourceCode = existingItem.bringOutDataOne
    },
    disabledStartDateActive (value) {
      if (value.date() === 1) {
        return false;
      }
      return true;
    },
    disabledEndDateActive (value) {
      if (value.date() === value.daysInMonth()) {
        return false;
      }
      return true;
    },
    save () {
      const arr = this.$refs.dataTable.myDataSource
      // 遍历数组并将 sourceSupplierId 属性转换为字符串
      const transformedArr = arr.map(obj => {
        // 将 sourceSupplierId 属性的数字值转换为字符串
        obj.sourceSupplierId = obj.sourceSupplierId.toString();
        return obj;
      });
      if (transformedArr.length === 0) {
        this.$message.warning('请保存至少一条记录')
        return false
      }
      let flag = false
      for (let i = 0; i < transformedArr.length; i++) {
        if (!transformedArr[i].sourceSupplierId ||
        !transformedArr[i].month ||
            transformedArr[i].allocationPercent === '' ||
            transformedArr[i].allocationPercent === undefined) {
          this.$message.warning('必填项不能为空,保存失败!')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.isLoading = true
      apiMdmOrgSrAssignments(transformedArr).then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.$message.success(response.msg)
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      }).catch((error) => {
       // this.$message.error('保存失败')
        this.isLoading = false
        // 处理 API 调用失败的情况
        console.error('API 调用失败: ', error);
      })
    },
        // 新增行
    addLine () {
      const arr = this.$refs.dataTable.myDataSource
      const obj = {
        sourceOrganization: this.sourceOrganization,
        assignmentSetId: this.queryParams.assignmentSetId,
        itemCode: this.queryParams.itemCode,
        itemId: this.queryParams.itemId,
        sourceSupplierName: "",
        sourceSupplierId: "",
        allocationPercent: "",
        startDateActive: "",
        sourceCode: "",
        effectFlag: undefined,
        month: undefined,
        endDateActive: ""
      }
      arr.push(obj)
    },
        // 删除
   handleDelete (record) {
      const self = this
      this.$confirm({
          title: '警告',
          content: `真的要删除该项的数据项吗?`,
          okText: '删除',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            if (record.id) {
              apiDelItemApportion([record.id]).then(response => {
                if (response.code === 200) {
                  self.$message.success('保存成功')
                  self.onSearch()
                  self.isEdit = false;
                } else {
                  self.$message.error(response.msg)
                }
              })
            } else {
              const arr = self.$refs.dataTable.myDataSource
                arr.forEach((item, index) => {
                  if (item.id === record.id) {
                    arr.splice(index, 1);
                  }
                });
            }
          }
        })
    },
    // 列表-折换字段
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    statusOnChange (record) {
      record.status = record.status === 'Y' ? 'N' : 'Y'
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download('mdm/mdmUomConversions/export', {
        ...this.queryParams
      }, `标准单位转换_${new Date().getTime()}.xlsx`)
    },
    // getUnitOfMeasureList () {
    //   unitOfMeasurelist().then(res => {
    //     if (res.code === 200 && res.data && res.data.length > 0) {
    //       this.unitOfMeasureList = res.data;
    //     }
    //   })
    //   unitOfMeasurelist({ baseUomFlag: 'Y', status: 'Y' }).then(res => {
    //     if (res.code === 200 && res.data && res.data.length > 0) {
    //       this.unitOfMeasureListNew = res.data;
    //     }
    //   })
    // },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    // handleSave (record) {
    //   if (!record.conversionRate || Number(record.conversionRate) <= 0) {
    //     this.$message.warning('折换不能为空且需大于0')
    //     return
    //   }
    //   updateUnit(record).then(response => {
    //     if (response.code === 200) {
    //       this.$message.success('保存成功')
    //       this.onSearch()
    //       this.isEdit = false;
    //     } else {
    //       this.$message.error(response.msg)
    //     }
    //   })
    // },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        ...this.queryParams,
       // itemCode: undefined,
       // assignmentSetId: undefined,
        nowDate: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
/deep/.ant-select{
  width: 150px;
}
</style>
